import React, { useState } from 'react'
import Slider from 'react-slick'
import useStyles, { FormInputSelect } from './styles'
import Navbar2 from '../../components/Navbar2/Navbar2'
import Section from '../../components/Section/Section'
import Footer from '../../components/Footer/Footer'
import FormInputNoLabel from '../../components/FormInputNoLabel/FormInputNoLabel'
import Paragraph from '../../components/Typography/Paragraph'
import Card from '../../components/Card/Card'
import Loader from 'react-js-loader'

import giftbox from '../../assets/images/giftbox.png'
import wallet from '../../assets/images/wallet.png'
import slot from '../../assets/images/slot.png'
import result from '../../assets/images/result.png'
import event from '../../assets/images/event.png'
import subscribe from '../../assets/images/subscribe.png'

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox
} from '@mui/material'
import Button from '../../components/Button/Button'
import {
  AddCircle,
  MoreVert,
  Edit,
  Delete,
  RemoveCircle
} from '@mui/icons-material'
import {
  get_banner,
  add_shipping_charge,
  edit_shipping_charge,
  delete_shipping_charge,
  get_category,
  get_shipping_country,
  edit_shipping_country,
  get_upload_file,
  add_banner,
  edit_banner,
  delete_banner,
  get_color,
  add_color,
  edit_color,
  delete_color
} from '../../API/API'
import Countdown from 'react-countdown'
import moment from 'moment/moment'

import './styles.css'
import FormInput from '../../components/FormInput/FormInput'
import { useNavigate, useLocation } from 'react-router-dom'
import toast from 'react-simple-toasts'

export default function Color() {
  const classes = useStyles()
  const navigate = useNavigate()
  const location = useLocation()

  const [sort, setSort] = React.useState(0)

  const handleChangeSort = event => {
    setSort(event.target.value)
  }

  const [searchKey, setSearchKey] = React.useState('')
  const handleSearch = event => {
    setSearchKey(event.target.value)
  }

  const [loading, setLoading] = useState(false)
  const [totalList, setTotalList] = React.useState(1)
  const [pageNum, setPageNum] = React.useState(0)

  const [listData, setlistData] = React.useState(null)
  const [countryList, setCountryList] = React.useState(null)
  const [categoryList, setClassList] = React.useState(null)

  const [openAdd, setOpenAdd] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [selectedColor, setSelectedColor] = React.useState(null);
  const [addData, setAddData] = React.useState({
    name: ""
  });
  const [openEditCountry, setOpenEditCountry] = React.useState(false);
  const [countryData, setCountryData] = React.useState({
    shipping_country_id: "",
    default_shipping: "",
  });

  const getData = () => {
    setLoading(true)
    get_color({
      //   page: pageNum + 1
      // sort: sort
    }).then(json => {
      setLoading(false)
      setlistData(json.data)
      //   setTotalList(json.total)
    })
  }

  React.useEffect(() => {
    getData()
  }, [pageNum, sort])

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage)
    // getData();
  }

  const handleCaptureSingle = async (e, index) => {
    var formData = new FormData();
    // var token = window.localStorage.getItem("token");
    // formData.append("token", token);
    formData.append('image', e.target.files[0]);
    // setisLoading(true);
    var res = await get_upload_file(formData);
    console.log(res)
    if (res.data.status) {
      setAddData({
        ...addData,
        image: res.data.data
      })
    } else {
      toast(res.data.message);
    }
  };

  const handleOpenAdd = e => {
    setOpenAdd(true)
    setAddData({
      name: ""
    });
  }
  const handleCloseAdd = value => {
    setOpenAdd(false)
  }

  const handleChangeAdd = (e) => {
    setAddData({
      ...addData,
      [e.target.name]: e.target.value,
    });
  };
  const handleAddColor = () => {
    if (addData.name.length == 0) {
      toast("Please enter color code")
      return
    }
    setLoading(true);
    add_color(addData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Color Added")
        handleCloseAdd();
        getData();
        setAddData({
          name: ""
        });
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  const handleOpenEdit = e => {
    setOpenEdit(true)
    setAddData({
      name: e.name,
      color_id: e.color_id
    });
  }
  const handleCloseEdit = value => {
    setOpenEdit(false)
  }

  const handleEditColor = () => {
    if (addData.name.length == 0) {
      toast("Please enter color code")
      return
    }
    setLoading(true);
    edit_color(addData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Color Edited")
        handleCloseEdit();
        getData();
        setAddData({
          name: ""
        });
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  const handleOpenDelete = e => {
    setOpenDelete(true)
    setSelectedColor(e)
  }
  const handleCloseDelete = value => {
    setOpenDelete(false)
  }
  const handleDeleteColor = () => {
    setLoading(true);
    delete_color({ color_id: selectedColor }).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Color Deleted")
        handleCloseDelete();
        getData();
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  const handleOpenEditCountry = e => {
    setOpenEditCountry(true)
    setCountryData({
      shipping_country_id: e.shipping_country_id,
      default_shipping: e.default_shipping,
    });
  }
  const handleCloseEditCountry = value => {
    setOpenEditCountry(false)
  }

  const handleEditCountry = () => {
    setLoading(true);
    edit_shipping_country(countryData).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Shipping Default Changed")
        handleCloseEditCountry();
        getData();
        setCountryData({
          shipping_country_id: "",
          default_shipping: "",
        });
      } else {
        setLoading(false);
        toast(json.message)
      }
    });
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: 'auto' }}>
          <Loader type='bubble-loop' bgColor='#1A5386' size={50} />
        </div>
      ) : (
        <Navbar2
          children={
            <Section pd='2rem'>
              <div>
                <div className={classes.theFlexHeader}>
                  <Paragraph color='#1A5386' bold='600' size='24px'>
                    Color
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: '0' }}
                  >
                    <a
                      className={classes.theCustomActionBtn_}
                      onClick={() => handleOpenAdd()}
                    >
                      <AddCircle sx={{ color: '#1A5386' }} />
                      <Paragraph color='#1A5386' margin='0 0 0 .4rem'>
                        Add Color
                      </Paragraph>
                    </a>
                    {/* <a
                                            className={classes.theCustomActionBtn_}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <ExitToApp sx={{ color: "#707070" }} />
                                            <Paragraph margin="0 0 0 .4rem">Export</Paragraph>
                                        </a> */}
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: '2px solid #707070',
                    padding: '.2rem 0'
                  }}
                />
                <br />

                <div className={classes.theFlexAction}>
                  {/* <div
                    className={classes.theWx}
                    style={{ margin: '0 20px 0 0' }}
                  >
                    <FormInputNoLabel
                      placeholder='Search'
                      border='1px solid #d7d7d7'
                      br='6px'
                      onChange={handleSearch}
                      value={searchKey}
                    />
                  </div> */}
                  {/* <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                            <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={(e) => console.log(e.target.value)}
                                value={searchKey}
                                type="date"
                            />
                        </div> */}
                  {/* <div className={classes.theWx}>
                            <div className={classes.theFlex_}>
                                <FormInputSelect>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={sort}
                                        // defaultValue={sort}
                                        onChange={handleChangeSort}
                                    >
                                        <MenuItem value="0" style={{ color: "#000" }}>
                                            All Payment Type
                                        </MenuItem>
                                        <MenuItem value="1" style={{ color: "#000" }}>
                                            Paid
                                        </MenuItem>
                                        <MenuItem value="2" style={{ color: "#000" }}>
                                            On Hold
                                        </MenuItem>
                                        <MenuItem value="3" style={{ color: "#000" }}>
                                            Cancelled
                                        </MenuItem>
                                    </Select>
                                </FormInputSelect>
                            </div>
                        </div> */}
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: '#1A5386' }}>
                            <TableRow>
                              <TableCell
                                style={{ borderRadius: '10px 0 0 10px' }}
                                className={classes.theHeadTitle}
                              >
                                Color Code
                              </TableCell>
                              {/* <TableCell
                                className={classes.theHeadTitle}
                              >
                                Weight
                              </TableCell>
                              <TableCell
                                className={classes.theHeadTitle}
                              >
                                Title
                              </TableCell>
                              <TableCell
                                className={classes.theHeadTitle}
                              >
                                Subtitle
                              </TableCell> */}
                              <TableCell
                                align="center"
                                style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                <MoreVert sx={{ color: "#fff" }} />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {listData != null &&
                              listData.map((item, index) => {
                                // if (searchKey != '') {
                                //   if (
                                //     item.postcode.indexOf(
                                //       searchKey.toUpperCase()
                                //     ) <= -1
                                //   ) {
                                //     return
                                //   }
                                // }
                                return (
                                  <TableRow>
                                    <a
                                      style={{ display: 'contents' }}
                                    // href={`../saledetail/${item.sales_order_id}`}
                                    >
                                      <TableCell
                                        style={{
                                          // textDecoration: 'underline',
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: 'top'
                                        }}
                                      >
                                        <div style={{
                                          display: 'flex',
                                          alignItems: "center"
                                        }}>
                                          <div style={{
                                            backgroundColor: item.name,
                                            width: '25px',
                                            height: '25px',
                                            borderRadius: "50%",
                                            border: "1px solid #1A5386",
                                            margin: "0 10px 0 0"
                                          }}></div>
                                          {item.name}
                                        </div>
                                      </TableCell>
                                      {/* <TableCell
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: 'top'
                                        }}
                                      // onClick={() =>
                                      //   navigate(
                                      //     '/customerdetail/' +
                                      //     item.customer_id
                                      //   )
                                      // }
                                      >
                                        {item.weight}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: 'top'
                                        }}
                                      // onClick={() =>
                                      //   navigate(
                                      //     '/customerdetail/' +
                                      //     item.customer_id
                                      //   )
                                      // }
                                      >
                                        {item.title}
                                      </TableCell> */}
                                      {/* <TableCell
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          verticalAlign: 'top'
                                        }}
                                      // onClick={() =>
                                      //   navigate(
                                      //     '/customerdetail/' +
                                      //     item.customer_id
                                      //   )
                                      // }
                                      >
                                        {item.subtitle}
                                      </TableCell> */}
                                      <TableCell
                                        align="center"
                                        style={{
                                          background: index % 2 == 0 ? "#f2f2f2" : "#fff",
                                          width: "10%",
                                          verticalAlign: 'top'
                                        }}
                                      >
                                        <Button
                                          onClick={() => handleOpenEdit(item)}
                                          label="Edit"
                                          color="#fff"
                                          bg="#1A5386"
                                          size="12px"
                                          pd="10px"
                                          br="5px"
                                          style={{ marginBottom: "10px" }}
                                        />
                                        <Button
                                          onClick={() => handleOpenDelete(item.color_id)}
                                          label="Delete"
                                          color="#1A5386"
                                          bg="#fff"
                                          box="1px solid #1A5386"
                                          size="12px"
                                          pd="10px"
                                          br="5px"
                                        />
                                      </TableCell>
                                    </a>
                                  </TableRow>
                                )
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      {/* <div
                        style={{
                          borderTop: '1px solid #707070',
                          borderBottom: '1px solid #707070',
                          margin: '1rem 0 0',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'flex-end'
                        }}
                      >
                        <TablePagination
                          // variant="outlined"
                          color='primary'
                          page={pageNum}
                          onPageChange={handleChangePage}
                          count={totalList}
                          // defaultPage={pageList}
                          rowsPerPage={10}
                          rowsPerPageOptions={[10]}
                          // count={10}
                        />
                      </div> */}
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />
              </div>

              <Dialog
                onClose={handleCloseAdd}
                open={openAdd}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Add Color
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormInput
                        label="Color Code*"
                        value={addData.name}
                        textLabelColor="#000"
                        placeholder="Color Code"
                        name="name"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                  </Grid>
                  <Button
                    onClick={() => handleAddColor()}
                    label="Add"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseEdit}
                open={openEdit}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Edit Color
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>

                    <Grid item xs={12} sm={12} md={12}>
                      <FormInput
                        label="Color Code*"
                        value={addData.name}
                        textLabelColor="#000"
                        placeholder="Color Code"
                        name="name"
                        border="1px solid #c5c5c5"
                        onChange={handleChangeAdd}
                      >
                      </FormInput>
                    </Grid>
                  </Grid>
                  <Button
                    onClick={() => handleEditColor()}
                    label="Save"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>

              <Dialog
                onClose={handleCloseDelete}
                open={openDelete}
                fullWidth='true'
                maxWidth='sm'
              >
                <DialogTitle>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Delete Color
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Paragraph color="#000" bold="600" size="16px" margin="0 0 1rem">
                    Are you sure to delete this color?
                  </Paragraph>
                  <Button
                    onClick={() => handleDeleteColor()}
                    label="Delete"
                    color="#fff"
                    bg="#1A5386"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>
            </Section>
          }
        />
      )}
    </React.Fragment>
  )
}
